import { useFaqModal } from '@/hooks/useFaqModal';
import { AnimatePresence, motion } from 'framer-motion';
import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import animations from '../../helpers/animations';
import {
    AccordionItemContainer,
    BackgroundModal,
    CloseModalButton,
    ModalWrapper,
} from './styles';
import useMeasure from '@/hooks/useMeasure';
import { LuChevronDown } from 'react-icons/lu';

const AccordionItem = ({
    isOpen,
    setIsOpen,
}: {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
}) => {
    const [ref, size] = useMeasure();

    return (
        <AccordionItemContainer
            onClick={() => setIsOpen(!isOpen)}
            className="accordion"
        >
            <div className="accordion-header">
                <h2>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </h2>
                <motion.span
                    className="accordion-button"
                    animate={{ rotate: isOpen ? 180 : 0 }}
                >
                    <LuChevronDown />
                </motion.span>
            </div>
            <motion.div
                style={{ height: 0 }}
                animate={{ height: isOpen ? size.height : 0 }}
                className="accordion-content"
            >
                <div
                    className="size-wrapper"
                    ref={ref}
                    style={{ paddingTop: '.5rem' }}
                >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut
                    et massa mi. Aliquam in hendrerit urna. Pellentesque sit
                    amet sapien fringilla, mattis ligula consectetur, ultrices
                    mauris. Lorem ipsum dolor sit amet, consectetur adipiscing
                    elit. Ut et massa mi. Aliquam in hendrerit urna.
                    Pellentesque sit amet sapien fringilla, mattis ligula
                    consectetur, ultrices mauris.
                </div>
            </motion.div>
        </AccordionItemContainer>
    );
};

export function FaqModal() {
    const modalRef = useRef<HTMLDivElement | null>(null);
    const faqModalStore = useFaqModal();
    const [currentOpenIndex, setCurrentOpenIndex] = useState<number | null>(
        null
    );

    function handleCloseModal() {
        faqModalStore.update({ isVisible: false });
    }

    return createPortal(
        <AnimatePresence>
            {faqModalStore.isVisible && (
                <BackgroundModal
                    ref={modalRef}
                    onClick={handleCloseModal}
                    {...animations.fadeInOut(0.1)}
                >
                    <ModalWrapper onClick={e => e.stopPropagation()}>
                        <div className="title">
                            <p>Informações</p>
                            <p className="description">
                                Veja algumas informações importantes que deve
                                saber sobre First Heats
                            </p>
                        </div>
                        <CloseModalButton onClick={handleCloseModal} />
                        <div className="column">
                            {Array(5)
                                .fill(0)
                                .map((_, index) => (
                                    <AccordionItem
                                        isOpen={currentOpenIndex === index}
                                        setIsOpen={newState => {
                                            if (!newState) {
                                                return setCurrentOpenIndex(
                                                    null
                                                );
                                            }
                                            setCurrentOpenIndex(index);
                                        }}
                                    />
                                ))}
                        </div>
                    </ModalWrapper>
                </BackgroundModal>
            )}
        </AnimatePresence>,
        document.getElementById('root')!
    );
}
